import { cn } from "@/infrastructure/lib/utils";
import { Loader2 } from "lucide-react";

interface PageLoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

export function PageLoadingSpinner({ 
  size = "md",
  showText = true,
  className,
  ...props 
}: PageLoadingSpinnerProps) {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn("flex flex-col items-center justify-center", showText ? "gap-4" : "", className)}
      {...props}
    >
      <Loader2 className={cn("animate-spin text-primary", sizeClasses[size])} />
      {showText && <p className="text-sm text-muted-foreground">Carregando...</p>}
    </div>
  );
}
